import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiMessageCircle, FiClock, FiCalendar } = FiIcons;

const ContactForm = () => {
  return (
    <section className="py-24 relative" style={{ backgroundColor: '#1e0f21' }}>
      <div className="absolute inset-0 overflow-hidden">
        <motion.div 
          className="absolute top-0 left-0 w-96 h-96 rounded-full opacity-20"
          style={{ background: 'radial-gradient(circle, rgba(177, 107, 189, 0.6) 0%, rgba(30, 15, 33, 0) 70%)', filter: 'blur(60px)' }}
          animate={{ x: [0, 100, 0], y: [0, 50, 0] }}
          transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div 
          className="absolute bottom-0 right-0 w-96 h-96 rounded-full opacity-20"
          style={{ background: 'radial-gradient(circle, rgba(255, 215, 0, 0.3) 0%, rgba(30, 15, 33, 0) 70%)', filter: 'blur(60px)' }}
          animate={{ x: [0, -50, 0], y: [0, 80, 0] }}
          transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <motion.div initial={{ y: 30, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} transition={{ duration: 0.8 }} viewport={{ once: true }} className="text-center mb-16">
          <motion.h2 className="text-4xl md:text-5xl font-bold mb-6 text-purple-100" animate={{ textShadow: ["0 0 0px rgba(255, 215, 0, 0)", "0 0 15px rgba(255, 215, 0, 0.5)", "0 0 0px rgba(255, 215, 0, 0)"] }} transition={{ duration: 3, repeat: Infinity }}>
            For Free Consultation
          </motion.h2>
          <p className="text-xl text-purple-200 mb-8">
            Contact us today to start your digital growth journey
          </p>
        </motion.div>

        <motion.div initial={{ y: 50, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} transition={{ duration: 0.8, delay: 0.2 }} viewport={{ once: true }} className="grid lg:grid-cols-3 gap-8 mb-16">
          <motion.div className="bg-purple-900 bg-opacity-20 backdrop-blur-sm rounded-2xl p-6 border border-purple-700 hover:border-yellow-400 transition-all duration-300 flex items-center" whileHover={{ scale: 1.02, boxShadow: '0 0 30px rgba(255, 215, 0, 0.2)' }}>
            <motion.div className="p-4 rounded-full bg-purple-800 bg-opacity-50 mr-5 shrink-0" whileHover={{ scale: 1.1, backgroundColor: 'rgba(255, 215, 0, 0.2)' }}>
              <SafeIcon icon={FiPhone} className="text-2xl" style={{ color: '#FFD700' }} />
            </motion.div>
            <div>
              <h3 className="text-sm font-semibold text-yellow-300 uppercase tracking-wider mb-1">Call Us</h3>
              <a href="tel:+917796983999" className="text-xl font-bold text-purple-100 hover:text-yellow-300 transition-colors duration-300">+91-77-969-83-999</a>
            </div>
          </motion.div>

          <motion.div className="bg-purple-900 bg-opacity-20 backdrop-blur-sm rounded-2xl p-6 border border-purple-700 hover:border-yellow-400 transition-all duration-300 flex items-center" whileHover={{ scale: 1.02, boxShadow: '0 0 30px rgba(255, 215, 0, 0.2)' }}>
            <motion.div className="p-4 rounded-full bg-purple-800 bg-opacity-50 mr-5 shrink-0" whileHover={{ scale: 1.1, backgroundColor: 'rgba(255, 215, 0, 0.2)' }}>
              <SafeIcon icon={FiMail} className="text-2xl" style={{ color: '#FFD700' }} />
            </motion.div>
            <div className="overflow-hidden">
              <h3 className="text-sm font-semibold text-yellow-300 uppercase tracking-wider mb-1">Email Us</h3>
              <a href="mailto:hello@advertisingpandit.com" className="text-lg font-bold text-purple-100 hover:text-yellow-300 transition-colors duration-300 block truncate">hello@advertisingpandit.com</a>
            </div>
          </motion.div>

          <motion.div className="bg-purple-900 bg-opacity-20 backdrop-blur-sm rounded-2xl p-6 border border-purple-700 hover:border-yellow-400 transition-all duration-300 flex items-center" whileHover={{ scale: 1.02, boxShadow: '0 0 30px rgba(255, 215, 0, 0.2)' }}>
            <motion.div className="p-4 rounded-full bg-purple-800 bg-opacity-50 mr-5 shrink-0" whileHover={{ scale: 1.1, backgroundColor: 'rgba(255, 215, 0, 0.2)' }}>
              <SafeIcon icon={FiClock} className="text-2xl" style={{ color: '#FFD700' }} />
            </motion.div>
            <div>
              <h3 className="text-sm font-semibold text-yellow-300 uppercase tracking-wider mb-1">Business Hours</h3>
              <p className="text-sm font-bold text-purple-100 leading-tight">
                Mon - Fri: 9:00 AM - 7:00 PM<br />
                Sat - Sun: 10:00 AM - 5:00 PM
              </p>
            </div>
          </motion.div>
        </motion.div>

        <motion.div initial={{ y: 30, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} transition={{ duration: 0.8, delay: 0.4 }} viewport={{ once: true }} className="text-center">
          <motion.div className="inline-block" whileHover={{ scale: 1.05 }}>
            <motion.a
              href="https://form.rocketalgo.in/8303216"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-12 py-6 text-xl font-bold rounded-full transition-all duration-300 shadow-2xl"
              style={{ backgroundColor: '#FFD700', color: '#3a1c40' }}
              animate={{ boxShadow: ["0 0 0px rgba(255, 215, 0, 0)", "0 0 20px rgba(255, 215, 0, 0.5)", "0 0 0px rgba(255, 215, 0, 0)"] }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <SafeIcon icon={FiCalendar} className="mr-3" />
              Book Your Free Consultation Now
            </motion.a>
          </motion.div>
        </motion.div>
        
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.6 }} viewport={{ once: true }} className="mt-12 text-center">
          <motion.div className="flex items-center justify-center space-x-2 text-purple-200" animate={{ opacity: [0.7, 1, 0.7] }} transition={{ duration: 3, repeat: Infinity }}>
            <SafeIcon icon={FiMessageCircle} className="text-lg" style={{ color: '#FFD700' }} />
            <span className="text-lg">Our team is ready to help you grow your business</span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactForm;